import { Navigate, createFileRoute } from "@tanstack/react-router";
import Loading from "../../../components/core/blocks/Loading";
import { useVerifyEmail } from "../../../modules/auth/api/useVerifyEmail";

const VerifyEmail = () => {
  const { user_token: token } = Route.useSearch();
  const verification = useVerifyEmail(token);

  if (token === undefined) {
    return <Navigate to="/user/dashboard" replace />;
  }

  if (verification.isPending) {
    return <Loading />;
  }

  return <Navigate to="/user/dashboard" search={{ verify: String(verification.isSuccess) }} replace />;
};

export const Route = createFileRoute("/_authenticated/user/verify")({
  component: VerifyEmail,
  staticData: { application: "Admin" },
});
